if (!customElements.get('pp-product-gallery')) {
  customElements.define('pp-product-gallery', class extends HTMLElement {
    disconnectedCallback() { this.observer?.disconnect(); }
    connectedCallback() {
      if (this.initialized) {
        const track = this.querySelector('.pp-colour-gallery__track');
        if (track) this.observer?.observe(track);
        return;
      }
      this.initialized = true;
      const photos = [...this.querySelectorAll('[data-photo]')];
      const track = this.querySelector('.pp-colour-gallery__track');
      const dialog = this.querySelector('dialog');
      let current = 0;
      let opener;
      const show = index => {
        current = (index + photos.length) % photos.length;
        const img = dialog.querySelector('img');
        img.src = photos[current].href;
        img.alt = photos[current].querySelector('img').alt;
        dialog.querySelector('[data-counter]').textContent = `${current + 1} / ${photos.length}`;
      };
      if (dialog && typeof dialog.showModal === 'function') {
        photos.forEach((photo, index) => photo.addEventListener('click', event => {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          if (photo.dataset.zoom !== 'true') return;
          event.preventDefault();
          opener = photo;
          show(index);
          dialog.showModal();
        }));
        dialog.querySelector('[data-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
        });
        dialog.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => show(current + Number(button.dataset.step))));
        dialog.addEventListener('keydown', event => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            show(current + (event.key === 'ArrowRight' ? 1 : -1));
          }
        });
        dialog.addEventListener('close', () => opener?.focus({preventScroll:true}));
      }
      const nav = this.querySelector('.pp-colour-gallery__navigation');
      if (nav) {
        nav.hidden = false;
        const update = () => {
          nav.querySelector('[data-scroll="-1"]').disabled = track.scrollLeft < 2;
          nav.querySelector('[data-scroll="1"]').disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        };
        track.addEventListener('scroll', update, {passive:true});
        this.observer = new ResizeObserver(update);
        this.observer.observe(track);
        update();
        nav.querySelectorAll('[data-scroll]').forEach(button => button.addEventListener('click', () => {
          const gap = parseFloat(getComputedStyle(track).gap) || 12;
          track.scrollBy({left: Number(button.dataset.scroll) * (photos[0].getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        }));
      }
    }
  });
}
